import { getModuleGroupByName } from '@softline/application';
import {
  provideSoftAppsModule,
  withSoftAppsModuleNavItem,
  withSoftAppsModuleRoutes,
  withSoftAppsModuleTranslation,
} from '@softapps/core';
import { default as de } from '../i18n/de.json';
import { default as en } from '../i18n/en.json';
import { aiTableExtractorRoutes } from './ai-table-extractor.routes';
import {
  AiTableExtractorModuleConfig,
  DEFAULT_AI_TABLE_EXTRACTOR_CONFIG,
  SOFTLINE_CONFIG_AI_TABLE_EXTRACTOR,
  SOFTLINE_MODULE_AI_TABLE_EXTRACTOR,
  SOFTLINE_PERMISSION_AI_TABLE_EXTRACTOR,
} from './ai-table-extractor.shared';

// Cross-domain for now; move to 'Warenwirtschaft' once the module settles there.
const MODULE_GROUP_NAME = 'Workflow';

export const provideAiTableExtractorModule = (
  config?: AiTableExtractorModuleConfig
) => {
  return [
    {
      provide: SOFTLINE_CONFIG_AI_TABLE_EXTRACTOR,
      useValue: { ...DEFAULT_AI_TABLE_EXTRACTOR_CONFIG, ...config },
    },
    provideSoftAppsModule(
      {
        name: SOFTLINE_MODULE_AI_TABLE_EXTRACTOR,
        title: '#AI_TABLE_EXTRACTOR.TITLE',
        icon: 'fa-regular fa-file-import',
        route: '/ai-table-extractor',
        permission: SOFTLINE_PERMISSION_AI_TABLE_EXTRACTOR,
        group: getModuleGroupByName(MODULE_GROUP_NAME),
      },
      withSoftAppsModuleRoutes({ app: aiTableExtractorRoutes }),
      withSoftAppsModuleTranslation({ de, en }),
      withSoftAppsModuleNavItem([
        {
          name: 'ai-table-extractor-upload',
          title: '#AI_TABLE_EXTRACTOR.UPLOAD_PAGE_TITLE',
          icon: 'fa-regular fa-file-import',
          routerLink: ['/ai-table-extractor/upload'],
          entry: true,
        },
      ])
    ),
  ];
};
